'use client'

import { useEffect } from 'react'
import Script from 'next/script'
import {
  identify as analyticsIdentify,
  resetIdentity as analyticsResetIdentity,
  initHeap,
} from '@phoenix-web/analytics'
import { useConsentCheck } from '@phoenix-web/react-hooks'
import {
  COOKIE_YES_CONSENT_COOKIE,
  DISABLE_ALL_ANALYTICS,
  GTAG_ID,
  HEAP_TOKEN,
  KNOCK_PRIVACY_COOKIE,
} from '@/constants'

export default function AnalyticsLoader() {
  const [hasAnalyticsConsent] = useConsentCheck({
    cookieYesName: COOKIE_YES_CONSENT_COOKIE,
    knockPrivacyName: KNOCK_PRIVACY_COOKIE,
    categoryName: 'analytics',
  })
  const [hasFunctionalConsent] = useConsentCheck({
    cookieYesName: COOKIE_YES_CONSENT_COOKIE,
    knockPrivacyName: KNOCK_PRIVACY_COOKIE,
    categoryName: 'functional',
  })
  const isBrowser = typeof window !== 'undefined'

  useEffect(() => {
    if (isBrowser && !DISABLE_ALL_ANALYTICS && HEAP_TOKEN && hasFunctionalConsent) {
      initHeap({ heapToken: HEAP_TOKEN })
    }
  }, [hasFunctionalConsent, isBrowser])

  return isBrowser && !DISABLE_ALL_ANALYTICS && GTAG_ID && hasAnalyticsConsent ? (
    <>
      <Script src={`https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`} />
      <Script id="google-analytics">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', '${GTAG_ID}');
        `}
      </Script>
    </>
  ) : null
}

export async function identify({ accountId }: { accountId: number }) {
  if (!HEAP_TOKEN) return
  await analyticsIdentify({ knockAccountId: accountId })
}

export function resetIdentity() {
  analyticsResetIdentity()
}
